(function ($) {
    $.fn.traineeOrTrainerPickerReset = function() {
        var $this = $(this);
        var $hiddenField = $('#' + $this.attr('id') + 'Id');
        $this.val('');
        $hiddenField.val('');
        return this;
    };
}(jQuery));